import { useState } from 'react';
import { faqItems } from '@/mocks/homeData';

export default function FaqSection() {
  const [openId, setOpenId] = useState<number>(1);

  return (
    <section id="faq" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-secondary-500/15 text-secondary-300 border border-secondary-500/20 mb-4">
            帮助中心
          </span>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-50">
            常见问题
          </h2>
          <p className="mt-3 text-sm text-foreground-400 max-w-lg mx-auto">
            关于黑料官网的常见疑问与解答
          </p>
        </div>

        <div className="max-w-[800px] mx-auto flex flex-col gap-3">
          {faqItems.map((item) => {
            const isOpen = openId === item.id;
            return (
              <div
                key={item.id}
                className="rounded-xl bg-background-50 border border-background-200/50 overflow-hidden"
              >
                <button
                  className="w-full flex items-center justify-between gap-4 p-4 md:p-5 text-left cursor-pointer"
                  onClick={() => setOpenId(isOpen ? 0 : item.id)}
                >
                  <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-100 pr-2">
                    {item.question}
                  </h3>
                  <div className={`shrink-0 w-7 h-7 rounded-full flex items-center justify-center transition-colors ${
                    isOpen ? 'bg-primary-500/20 text-primary-400' : 'bg-background-100 text-foreground-500'
                  }`}>
                    <i className={`text-sm transition-transform duration-300 ${isOpen ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                  </div>
                </button>
                <div
                  className={`transition-all duration-300 ease-in-out overflow-hidden ${
                    isOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <p className="px-4 md:px-5 pb-4 md:pb-5 text-sm text-foreground-400 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}